import styled from 'styled-components';


interface ContainerProps {

}

export const Container = styled.div<ContainerProps>`
  padding: 20px;
  height:100%;
`;


